// extracted by mini-css-extract-plugin
export default {"title":"Title_title__sN0LS","subTitle":"Title_subTitle__lhHxC"};